import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgGridModule, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { PrismStatusIndicatorComponent } from '@shure/prism-angular-components';
import { DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

export type DeviceStateRendererComponentParamsType = ICellRendererParams<object, DeviceStatus>;

/**
 * ```sh-device-state-renderer``` is a view component for displaying device state component
 */
@Component({
	selector: 'sh-device-state-renderer',
	templateUrl: './device-state-renderer.component.html',
	styleUrls: ['./device-state-renderer.component.scss'],
	standalone: true,
	imports: [CommonModule, AgGridModule, PrismStatusIndicatorComponent, MatIconModule]
})
export class DeviceStateRendererComponent implements ICellRendererAngularComp {
	public params!: DeviceStateRendererComponentParamsType;
	public cellData?: DeviceStatus;
	public deviceStatus = signal<DeviceStatus>(DeviceStatus.Discovered);
	public prismState = computed(() => this.mapToPrismState(this.deviceStatus()));

	public agInit(params: DeviceStateRendererComponentParamsType): void {
		this.update(params);
	}

	public refresh(params: DeviceStateRendererComponentParamsType): boolean {
		this.update(params);
		return true;
	}

	private mapToPrismState(deviceStatus: DeviceStatus): string {
		switch (deviceStatus) {
			case DeviceStatus.Online:
				return 'good';
			case DeviceStatus.Offline:
				return 'inactive';
			case DeviceStatus.Discovered:
				return 'ok';
			case DeviceStatus.Error:
				return 'bad';
			default:
				return '';
		}
	}

	private update(params: DeviceStateRendererComponentParamsType): void {
		this.params = params;
		this.cellData = params.value ?? undefined;
		this.deviceStatus.set(this.cellData ?? DeviceStatus.Discovered);
	}
}
